export default {
  getLocale: state => {
    return state.locale
  },
  getLang: state => {
    return state.currentLanguage
  },
  getContainerClass: state => {
    return state.containerClass
  },
  getLayout (state) {
    return state.layout
  },
  getDashboardTitle (state) {
    return state.dashboardTitle
  },
  menuData (state) {
    return state.menuData
  },
  actionType (state) {
    return state.actionType
  },
  masterType (state) {
    return state.masterType
  },
  masterTypeName (state) {
    return state.masterTypeName
  },
  serviceTypeName(state){
    return state.serviceTypeName
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js